import parseBarcode from "../../rfid/BarcodeParser.min";
import {ltrim} from "../../../util/helperFunctions";
import {addErrorAlert, addPluginRequestSaleNotes, closeDialogue} from "../../actions";
import {getTranslate} from "../../../localization/localizeSlice";

export const onServicePlanDetected = (store, state) => {
    let dispatch = store.dispatch;
    let translate = getTranslate(state);
    const tryAskInfo = (initialValues) => {
        let inputState = {};
        let id = 'bikeInformationDialogue';
        store.dispatch({
            type: 'SHOW_DIALOGUE',
            payload: {
                id,
                title: 'Enter bike information',
                inputFields: [
                    {id: "make", name: "Make"},
                    {id: "model", name: "Model"},
                    {id: "serial", name: "Serial number (scan the bike barcode)"}
                ],
                initialValues,
                onDone: (inputValues, close, setValidationErrors) => {
                    console.log('Bike information', inputValues);
                    const errors = Object.keys(inputValues).reduce((acc, el) => {
                        if(inputValues[el] === ""){
                            acc[el] = "Please fill this field";
                        }
                        return acc;
                    }, {});
                    if(Object.keys(errors).length > 0){
                        setValidationErrors(errors);
                        return;
                    }
                    dispatch(addPluginRequestSaleNotes([translate("Service plan details: make - ${make}, model - ${model}, serial - ${serial}", inputValues)]));
                    close();
                },
                onChange: (newState, activeInputId, changeInput, validationErrors, setValidationErrors, inputValues) => {
                    inputState = inputValues;
                },
                canClose: false,
                closeOnDone: false,
                multipleInputDialogue: true,
                keyboardLayout: 'letters',
                onScannerDetect: (code) => {
                    console.log("onScannerDetect", {code, inputState});
                    let showError = () => dispatch(addErrorAlert('Serial number not found in the barcode'));
                    try {
                        let barcode = parseBarcode(code);
                        let serialItem = barcode.parsedCodeItems.find(el => el.dataTitle === 'SERIAL');
                        if(typeof serialItem !== "undefined"){
                            inputState['serial'] = ltrim(serialItem.data, '0');
                            dispatch(closeDialogue(id));
                            tryAskInfo(inputState);
                        }else{
                            showError();
                        }
                    }catch (e){
                        showError();
                    }
                }
            }
        });
    }

    tryAskInfo();
}
